import gql from "graphql-tag";

const StaffProps = gql`
    fragment StaffProps on Staff {
        id
        first_name
        middle_name
        nin
        email
        mobile
        surname
        designation {
            id
            name
        }
    }
`;

const PatientProps = gql`
    fragment PatientProps on Patient {
        id
        hcn
        dob
        gender
        name
        occupation
        address
        telNumber
        email
        admitted
        created_at
        lastAdmission
        profile_picture
        allergies {
            id
            name
        }
        profile_picture
        nextOfKin {
            id
            name
            created_at
            relationship
            address
            telNumber
        }
        history
        gp {
            name
            address
            email
            post_code
            mobile
        }
        doctor {
            ...StaffProps
        }
        psychiatrist {
            ...StaffProps
        }
        primary_nurse {
            ...StaffProps
        }
    }
    ${StaffProps}
`;

const NEW_PATIENT = gql`
    mutation NewPatient($model: PatientInput!) {
        NewPatient(model: $model) {
            message
            doc {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;

const QUERY = {
    GETPATIENT: gql`
        query GetPatient($id: ID!) {
            GetPatient(id: $id) {
                message
                doc {
                    ...PatientProps
                    site {
                        id
                        name
                    }
                    interest
                    section
                    rejection
                    observation
                    emergency_contact {
                        id
                        name
                        relationship
                        mobile
                        address
                    }
                    referral {
                        name
                        email
                        mobile
                    }
                }
            }
        }
        ${PatientProps}
    `,
    GETPATIENTID: gql`
        query GetPatientId($id: ID!) {
            GetPatient(id: $id) {
                doc {
                    name
                    id
                    lastAdmission
                    site {
                        id
                        name
                    }
                }
            }
        }
    `,
};

//  GET_PATIENT_LIST

const GET_PATIENT_LIST = gql`
    query GetPatients($page: Int, $limit: Int, $admitted: Boolean) {
        GetPatients(page: $page, limit: $limit, onlyAdmitted: $admitted) {
            docs {
                ...PatientProps
            }
            totalDocs
            totalPages
            nextPage
            prevPage
            page
        }
    }
    ${PatientProps}
`;

// patient admission
const NEW_ADMISSION = gql`
    mutation AdmitPatient($model: AdmissionInput!) {
        Admit(model: $model) {
            message
            doc {
                id
                author {
                    id
                    surname
                    email
                }
                patient {
                    id
                    name
                    hcn
                    admitted
                    profile_picture
                }
            }
        }
    }
`;

const UPDATE_ALLERGY = gql`
    mutation UpdateAllergy($patient: ID!, $items: [String!]!) {
        UpdatePatientAllergies(patient: $patient, allergies: $items) {
            message
            doc {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;

// next of kin
const NEW_NEXT_KIN = gql`
    mutation NewNextofKin($id: ID!, $model: NextOfKinInput!) {
        NewNextOfKin(patient: $id, model: $model) {
            status
            doc {
                address
                created_at
                id
                name
                telNumber
                relationship
            }
        }
    }
`;
const SINGLE = gql`
    query GetPatientSingle_($id: ID!) {
        GetPatient(id: $id) {
            message
            doc {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;
// Get Admission
const GET_ADMISSION = gql`
    query GetPatientAdmission($admission: ID!) {
        GetAdmission(id: $admission) {
            doc {
                id
                discharge_date
                admission_date
                created_at
                bed {
                    id
                    name
                    room {
                        id
                        name
                        ward {
                            id
                            name
                        }
                    }
                }
                author {
                    id
                    surname
                    first_name
                    middle_name
                    designation {
                        id
                        name
                    }
                }
            }
        }
    }
`;

const DISCHARGE = gql`
    mutation DischargePatient($id: ID!) {
        DischargePatient(id: $id) {
            message
            doc {
                id
                discharge_date
                admission_date
                created_at
                bed {
                    id
                    name
                    room {
                        id
                        name
                        ward {
                            id
                            name
                        }
                    }
                }
                author {
                    id
                    surname
                    first_name
                    middle_name
                    email
                    image
                    type {
                        id
                        name
                    }
                    designation {
                        id
                        name
                    }
                }
            }
        }
    }
`;

const UPDATE_PATIENT = gql`
    mutation UpdatePatientFunction($patient: ID!, $model: PatientUpdateInput!) {
        UpdatePatient(patient: $patient, model: $model) {
            message
            doc {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;
const GET_PATIENT_NHS = gql`
    query GetPatientByNumber($hcn: String!) {
        GetPatientByNumber(hcn: $hcn) {
            doc {
                id
                name
                address
                dob
                email
                gender
                lastAdmission
                hcn
                profile_picture
            }
        }
    }
`;
const UPDATE_HISTORY = gql`
    mutation UpdateHistory($id: ID!, $history: String!) {
        UpdatePatientHistory(id: $id, history: $history) {
            message
            doc {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;

const UPDATE_PATIENT_GP = gql`
    mutation UpdatePatientGP($id: ID!, $model: GPInput!) {
        UpdatePatientGP(id: $id, model: $model) {
            message
            doc {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;

const REMOVE_PATIENT = gql`
    mutation RemovePatient($id: ID!) {
        DeletePatient(patient: $id) {
            message
            doc {
                status
            }
        }
    }
`;

export const SET_DOCTOR = gql`
    mutation UpdateDoctor($id: ID, $staff: ID!) {
        UpdateDoctor(staff: $staff, id: $id) {
            message
        }
    }
`;
export const SET_NURSE = gql`
    mutation UpdateNurse($id: ID!, $staff: ID!) {
        UpdatePrimaryNurse(staff: $staff, id: $id) {
            message
        }
    }
`;

export const SET_PSYCHIATRIST = gql`
    mutation UpdatePsychiatrist($id: ID!, $staff: ID!) {
        UpdatePsychiatrist(staff: $staff, id: $id) {
            message
        }
    }
`;

export const UPDATE_SECTION = gql`
    mutation UpdateSection($id: ID!, $section: String!) {
        UpdateSection(id: $id, section: $section) {
            message
            doc {
                ...PatientProps
                section
            }
        }
    }
    ${PatientProps}
`;
export const UPDATE_REJECTION = gql`
    mutation UpdateRejection($id: ID!, $rejection: String!) {
        UpdateRejection(id: $id, rejection: $rejection) {
            message
            doc {
                ...PatientProps
                rejection
            }
        }
    }
    ${PatientProps}
`;

export const UPDATE_INTEREST = gql`
    mutation UpdateInterest($id: ID!, $interest: String!) {
        UpdateInterest(id: $id, interest: $interest) {
            message
            doc {
                ...PatientProps
                interest
            }
        }
    }
    ${PatientProps}
`;

export const UPDATE_OBS = gql`
    mutation UpdateOBS($id: ID!, $observation: String!) {
        UpdateObservation(id: $id, observation: $observation) {
            message
            doc {
                ...PatientProps
                observation
            }
        }
    }
    ${PatientProps}
`;

export const NEW_EMERGENCY_CONTACT = gql`
    mutation NewEmergencyContact($id: ID!, $model: ContactInput!) {
        UpdateEmergencyContact(id: $id, model: $model) {
            message
            doc {
                ...PatientProps
                emergency_contact {
                    id
                    name
                    relationship
                    address
                    mobile
                }
            }
        }
    }
    ${PatientProps}
`;

export const UPDATE_REFERRAL = gql`
    mutation UpdateReferralContact($id: ID!, $model: ReferralInput!) {
        UpdatePatientReferral(id: $id, model: $model) {
            message
            doc {
                ...PatientProps
                referral {
                    name
                    email
                    email
                }
            }
        }
    }
    ${PatientProps}
`;

export const GET_OUT_PATIENT = gql`
    query GetOutPatient($limit: Int, $page: Int) {
        GetOutPatients(page: $page, limit: $limit) {
            docs {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;
export const GET_IN_PATIENT = gql`
    query GetInPatient($limit: Int, $page: Int) {
        GetPatients(page: $page, limit: $limit, onlyAdmitted: true) {
            docs {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;

export const SEARCH_PATIENTS = gql`
    query SearchPatients($keyword: String!) {
        SearchPatientAll(keyword: $keyword) {
            docs {
                ...PatientProps
            }
        }
    }
    ${PatientProps}
`;

export {
    QUERY,
    NEW_PATIENT,
    GET_PATIENT_LIST,
    NEW_ADMISSION,
    PatientProps,
    UPDATE_ALLERGY,
    NEW_NEXT_KIN,
    SINGLE,
    GET_ADMISSION,
    DISCHARGE,
    UPDATE_PATIENT,
    GET_PATIENT_NHS,
    UPDATE_HISTORY,
    UPDATE_PATIENT_GP,
    REMOVE_PATIENT,
};
